ixModuleRouting("impactx.electronicdownload", {
    "/electronicdownloadlist": {
        template: "<ixa-electronic-download-list></ixa-electronic-download-list>",
        templateUrl:
            "modules/electronicdownload/templates/electronicdownload-list.html",
        controller: "ElectronicDownloadCtrl",
        controllerAs: "electronicDownloadCtrl",
        process: "ElectronicDownload",
        workspace: "shop",
    },
    "/electronicdownloadadminlist": {
        template: "<ixa-electronic-download-admin-list></ixa-electronic-download-admin-list>",
        templateUrl:
            "modules/electronicdownload/templates/electronicdownloadadmin-list.html",
        controller: "ElectronicDownloadAdminCtrl",
        controllerAs: "electronicDownloadAdminCtrl",
        process: "ElectronicDownloadAdmin",
        workspace: "content",
    },
});
